import angular from 'angular';
import { URL_PRIVACY_POLICY } from 'common/state';

import PrivacyPolicyComponent from './privacy-policy.cmpt';

export default angular
    .module('legal.scene.privacy-policy', [])
    .component(PrivacyPolicyComponent.selector, PrivacyPolicyComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('privacy-policy', {
        url: URL_PRIVACY_POLICY,
        component: PrivacyPolicyComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/legal/scene/privacy-policy/index.js